import { render, staticRenderFns } from "./Analisis.vue?vue&type=template&id=c33a1dd6&scoped=true&"
import script from "./Analisis.vue?vue&type=script&lang=js&"
export * from "./Analisis.vue?vue&type=script&lang=js&"
import style0 from "./Analisis.vue?vue&type=style&index=0&id=c33a1dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33a1dd6",
  null
  
)

export default component.exports